
var Constants = {
	// Sobreescrito en main.ts con environment.API_URL (dominio publico + context path).
	URL_BASE_SERVICES: window.location.origin
};
